import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModuleLoadingComponent } from './components/module-loading/module-loading.component';


@NgModule({
    declarations: [
        ModuleLoadingComponent
    ],
    exports: [
        ModuleLoadingComponent
    ],
    imports: [
        CommonModule
    ]
})
export class LoadingModule {
}
